var _path, _circle, _path2, _path3, _path4, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTransfer(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 0C18.2091 0 20 1.79086 20 4V16C20 18.2091 18.2091 20 16 20H4C1.79086 20 3.22133e-08 18.2091 0 16V7H5.33301C5.7012 7 6 6.77614 6 6.5C6 6.22386 5.7012 6 5.33301 6H0V5H3.5C3.77614 5 4 4.77614 4 4.5C4 4.22386 3.77614 4 3.5 4H0C0 1.79086 1.79086 3.22128e-08 4 0H16Z",
    fill: "url(#paint0_linear_2275_281)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 4,
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.598 11.109C11.598 11.3517 11.535 11.5803 11.409 11.795C11.2877 12.005 11.1057 12.18 10.863 12.32C10.625 12.4553 10.3427 12.5347 10.016 12.558V13.125H9.568V12.551C9.10133 12.509 8.72567 12.369 8.441 12.131C8.15633 11.8883 8.00933 11.5617 8 11.151H9.05C9.078 11.487 9.25067 11.69 9.568 11.76V10.423C9.232 10.339 8.96133 10.255 8.756 10.171C8.55067 10.087 8.37333 9.95167 8.224 9.765C8.07467 9.57834 8 9.324 8 9.002C8 8.596 8.14467 8.26467 8.434 8.008C8.728 7.75134 9.106 7.60434 9.568 7.567V7H10.016V7.567C10.464 7.60434 10.821 7.73967 11.087 7.973C11.3577 8.20634 11.5093 8.52834 11.542 8.939H10.485C10.471 8.80367 10.422 8.687 10.338 8.589C10.2587 8.48634 10.1513 8.414 10.016 8.372V9.695C10.366 9.78367 10.6413 9.87 10.842 9.954C11.0473 10.0333 11.2247 10.1663 11.374 10.353C11.5233 10.535 11.598 10.787 11.598 11.109ZM9.022 8.953C9.022 9.107 9.06867 9.233 9.162 9.331C9.25533 9.42434 9.39067 9.50134 9.568 9.562V8.351C9.4 8.37434 9.267 8.43734 9.169 8.54C9.071 8.64267 9.022 8.78034 9.022 8.953ZM10.016 11.774C10.1933 11.7413 10.331 11.669 10.429 11.557C10.5317 11.445 10.583 11.3097 10.583 11.151C10.583 10.997 10.534 10.8733 10.436 10.78C10.338 10.6867 10.198 10.6097 10.016 10.549V11.774Z",
    fill: "#474DE6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.55796 3.66862H8.26696L8.26709 4.51474H6V2.42074H6.90885V3.07123C7.79732 2.38731 8.91731 2 10.0842 2C12.5241 2 14.5915 3.62258 15 5.85829L14.104 6C13.77 4.17243 12.0795 2.846 10.0842 2.846C9.16065 2.846 8.27305 3.14261 7.55796 3.66862Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.442 16.3314H11.733L11.7329 15.4853H14V17.5793H13.0912V16.9288C12.2027 17.6127 11.0827 18 9.91584 18C7.47588 18 5.4085 16.3774 5 14.1417L5.89605 14C6.22998 15.8276 7.92054 17.154 9.91584 17.154C10.8393 17.154 11.7269 16.8574 12.442 16.3314Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2275_281",
    x1: 10,
    y1: 20,
    x2: 10,
    y2: 0,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3C40A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#474DE6"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTransfer);
export default __webpack_public_path__ + "static/media/TRANSFER.155aa086ef8d3c29642ee85aeeef3501.svg";
export { ForwardRef as ReactComponent };